"use client";

import React from "react";
import { Target, PenTool, Plane, ChartBar, Share2, Wrench } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const capabilities = [{
  title: "Terrestre",
  description: "Vive la experiencia definitiva en la isla blanca con acceso VIP a los clubes más exclusivos y villas de lujo frente al mar.",
  icon: Target
}, {
  title: "Brasil Temporada Baja",
  description: "Explora los mejores lugares con grupo privado, diseñado para capturar la esencia natural con el máximo confort.",
  icon: PenTool
}, {
  title: "Tickets Aereos",
  description: "Llega a todo el world de la manera mas fácil y cómoda. Consulta por tu destino perfecto!\xA0",
  icon: Plane
}, {
  title: "Paquetes",
  description: "Navega por aguas cristalinas en un yate privado visitando islas vírgenes y playas de arena blanca inalcanzables.",
  icon: ChartBar
}, {
  title: "Escapada a BUENOS AIRES",
  description: "Disfruta de la nieve en los resorts más prestigiosos de Europa con servicios de esquí personalizados y cenas gourmet.",
  icon: Share2
}, {
  title: "EXPLORAR SERVICIOS",
  description: "Ve nuestros servicios de Asistencia Medica; Alquiler de Auto; Paseos y Tours; etc.",
  icon: Wrench
}];
export default function LoDelMomento() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="263580" id="lo-del-momento" className="py-24 bg-background text-foreground overflow-hidden">
      <div ref={ref} className={`container mx-auto px-4 md:px-6 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 mb-16">
          <div className="max-w-2xl">
            <h2 className="text-4xl md:text-6xl font-bold font-default tracking-tighter mb-4 text-primary">
              Lo del Momento
            </h2>
          </div>
          <div className="md:max-w-md">
            <p className="text-muted-foreground text-xl font-serif leading-relaxed italic">
              Descubre las tendencias que están definiendo el lujo global. Destinos seleccionados para quienes buscan lo extraordinario.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {capabilities.map((item, i) => {
          const Icon = item.icon;
          return <div key={i} data-index={i} className="group flex flex-col p-8 rounded-lg border border-primary/30 bg-card hover:border-primary hover:shadow-lg transition-all duration-500">
                <div className="mb-6 relative">
                  <Icon className="w-8 h-8 text-primary group-hover:scale-110 transition-transform duration-300" strokeWidth={1} />
                  <div className="absolute -inset-2 bg-primary/10 rounded-lg blur-xl opacity-0 group-hover:opacity-100 transition-opacity" />
                </div>
                <h3 className="text-2xl font-bold font-default mb-3 text-card-foreground tracking-tight">
                  {item.title}
                </h3>
                <p className="text-muted-foreground font-sans leading-relaxed text-base">
                  {item.description}
                </p>
                <div className="mt-6 pt-6 border-t border-primary/10">
                  <span className="text-primary font-mono text-sm tracking-widest uppercase">Explorar Destino</span>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}